import React from 'react'
import PropTypes from 'prop-types'
import { formatValue } from 'state/utils'
import AnimatedNumber from 'react-animated-number'


function NumberCallout({label, value, className, valueOld}) {

  return (
    <div className={`NumberCallout ${className}`.trim()}>
      <div className="NumberCallout__heading">{label}</div>
      <div className="NumberCallout__value">
      <AnimatedNumber component="text" 
	      value={value}
	      initialValue={valueOld}
	      style={{
	          transition: '2s ease-out',
	          fontSize: 30,
	      }}
	      duration={500}
	      formatValue={n => formatValue(n)}
	      stepPrecision={2}
	      />
      </div>
    </div>
  )
}

export default NumberCallout

NumberCallout.defaultProps = {
  className: ''
}


// WEBPACK FOOTER //
// ./sections/wealth-breakdown/number-callout.js